// extracted by mini-css-extract-plugin
export default {"panel":"BentoPanel_panel__v+6Ux"};